import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxMediaQueryComponent } from './nx-media-query.component';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [
    NxMediaQueryComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [
    NxMediaQueryComponent
  ]
})
export class NxMediaQueryModule { }
